<template>
    <div class="column is-three-quarters right-side theme-style">
        <div class="dt-reorder">
            <gallery-box :car="car"></gallery-box>
        </div>
        <video-box v-if="!isMobile" :car="car"></video-box>
        <div class="other-section" v-if="!isMobile">
            <translate-box :car="car"></translate-box>
            <comments-box :car="car"></comments-box>
        </div>
    </div>
</template>

<script>
    import GalleryBox from './GalleryBox'
    import VideoBox from './VideoBox.vue'
    import CommentsBox from './CommentsBox'
    import TranslateBox from './Details/TranslationBox'
    export default {
        props: ['car'],
        components: {
            GalleryBox,
            VideoBox,
            CommentsBox,
            TranslateBox
        },
        computed: {
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        }
    }
</script>

<style scoped>
    .right-side {
        max-width: 100%;
    }
    .dt-reorder {
        display: flex;
        flex-direction: column;
    }
    /* mobile-first, reordering for desktop */
    @media screen and (min-width:767px){
        .dt-reorder >>> .gallery {
            order: 2;
        }
        .dt-reorder >>> .shipping {
            order: 1;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Cars/Car/RightSide.vue